/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// AUTOGENERATED BY glean_parser v19.0.0. DO NOT EDIT. DO NOT COMMIT.

import EventMetricType from '@mozilla/glean/private/metrics/event';

/**
 * User clicked on the "Forgot Password" Link.
 *
 * Generated from `cached_login.forgot_pwd_submit`.
 */
export const forgotPwdSubmit = new EventMetricType(
  {
    category: 'cached_login',
    name: 'forgot_pwd_submit',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Cached Sign in Submit
 * User submits the cached sign in form by clicking "Sign in"'
 *
 * Generated from `cached_login.submit`.
 */
export const submit = new EventMetricType(
  {
    category: 'cached_login',
    name: 'submit',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Cached Sign in Success (FE)
 * Successful submission of the cached sign-in form'
 *
 * Generated from `cached_login.success_view`.
 */
export const successView = new EventMetricType(
  {
    category: 'cached_login',
    name: 'success_view',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  []
);

/**
 * Cached Sign in View
 * A view of the cached sign-in form'
 *
 * Generated from `cached_login.view`.
 */
export const view = new EventMetricType<{
  third_party_links?: boolean;
}>(
  {
    category: 'cached_login',
    name: 'view',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['third_party_links']
);
